webpackJsonp([27],{

/***/ "/ZUY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_formvalidation__ = __webpack_require__("xiXx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_formvalidation_dist_es6_plugins_Bootstrap__ = __webpack_require__("YaPT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_formvalidation_dist_es6_plugins_Bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_formvalidation_dist_es6_plugins_Bootstrap__);



$(document).ready(function () {
    var form = document.getElementById('form-vehicle-contact');
    if (form !== null) {
        __WEBPACK_IMPORTED_MODULE_0_formvalidation__["a" /* formValidation */](form, {
            fields: {
                'lead_vehicle[lead][gender]': {
                    validators: {
                        notEmpty: {
                            message: "La civilité est obligatoire."
                        }
                    }
                },
                'lead_vehicle[lead][lastname]': {
                    validators: {
                        notEmpty: {
                            message: "Nom obligatoire."
                        },
                        stringLength: {
                            max: 80,
                            message: 'Maximum de 80 caractères.'
                        }
                    }
                },
                'lead_vehicle[lead][firstname]': {
                    validators: {
                        notEmpty: {
                            message: "Prénom obligatoire."
                        },
                        stringLength: {
                            max: 80,
                            message: 'Maximum de 80 caractères.'
                        }
                    }
                },
                'lead_vehicle[lead][phone]': {
                    validators: {
                        notEmpty: {
                            message: "Le téléphone est obligatoire."
                        },
                        stringLength: {
                            max: 10,
                            min: 10,
                            message: 'Le téléphone doit contenir 10 caractères.'
                        }
                    }
                },
                'lead_vehicle[lead][email]': {
                    validators: {
                        notEmpty: {
                            message: "L'adresse email est obligatoire."
                        },
                        emailAddress: {
                            message: "N'est pas une adresse mail valide."
                        }
                    }
                },
                'lead_vehicle[lead][zipcode]': {
                    validators: {
                        notEmpty: {
                            message: "Le code postal est obligatoire."
                        }
                    }
                },
                'lead_vehicle[lead][city]': {
                    validators: {
                        notEmpty: {
                            message: "La ville est obligatoire."
                        }
                    }
                }
            },
            plugins: {
                trigger: new __WEBPACK_IMPORTED_MODULE_0_formvalidation__["b" /* plugins */].Trigger(),
                bootstrap: new __WEBPACK_IMPORTED_MODULE_1_formvalidation_dist_es6_plugins_Bootstrap___default.a(),
                submitButton: new __WEBPACK_IMPORTED_MODULE_0_formvalidation__["b" /* plugins */].SubmitButton(),
                defaultSubmit: new __WEBPACK_IMPORTED_MODULE_0_formvalidation__["b" /* plugins */].DefaultSubmit(),
                /*icon: new FormValidation.plugins.Icon({
                    valid: 'fa fa-check',
                    invalid: 'fa fa-times',
                    validating: 'fa fa-refresh'
                }),*/ //Avec Bootstrap 4, ne pas oublier d'importer une fontIcons
                // declarative
                declarative: new __WEBPACK_IMPORTED_MODULE_0_formvalidation__["b" /* plugins */].Declarative({ html5Input: true })
            }
        });
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("/ZUY");
module.exports = __webpack_require__("K+v8");


/***/ }),

/***/ "K+v8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[14]);


// WEBPACK FOOTER //
// contact-vehicle.0c300d21bb709258ac83.js